import {fromJS} from 'immutable';
import {LOCATION_CHANGE} from 'react-router-redux';
import {combineReducers} from 'redux-immutable';

import applicationReducer from './containers/reducer';
import contentReducer from './content-manager/reducer';
import topbarReducer from './topbar/reducer';
import menuReducer from './menu/reducer';
import dialogReducer from './dialog/reducer';
import treeReducer, {mainReducer as treesReducer} from './components/tree/reducer';


const routerInitalState = fromJS({
    locationBeforeTransitions: null,
});

const routerReducer = (state = routerInitalState, action) => {
    if (action.type === LOCATION_CHANGE) {
        return state.merge({
            locationBeforeTransitions: action.payload,
        });
    }

    return state;
};

export default combineReducers({
    routing: routerReducer,
    application: applicationReducer,
    content: contentReducer,
    drawer: menuReducer,
    topbar: topbarReducer,
    dialogs: combineReducers({
        login: dialogReducer,
        registration: dialogReducer,
        welcome: dialogReducer,
        extra: combineReducers({
            levelsTree: treeReducer,
            gradesTree: treeReducer,
        }),
    }),
    trees: treesReducer,
});
